import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../../firebase/Firebase'; // Adjust the import path if necessary
import { doc, getDoc } from 'firebase/firestore';

const BlogInfo = () => {
    const { title } = useParams(); // Get the title from the URL
    const [blog, setBlog] = useState(null);

    // Fetch blog by title
    const fetchBlog = async () => {
        const docRef = doc(db, 'blogs', title.replace(/\+/g, ' ')); // Replace '+' with spaces for Firestore
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            setBlog(docSnap.data());
        } else {
            console.log("No such document!");
        }
    };

    useEffect(() => {
        fetchBlog();
    }, [title]);

    return (
        <div className="container mx-auto px-4 py-10">
            {blog ? (
                <>
                    <h1 className="text-3xl font-bold text-white mb-4">{blog.title}</h1>
                    <img src={blog.thumbnail} alt={blog.title} className="w-full h-64 object-cover mb-4" />
                    <div className="text-gray-300">
                        <p>{blog.content}</p> {/* Adjust based on your data structure */}
                    </div>
                </>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
};

export default BlogInfo;
